export function ConvertGeofencesToGeoJSON(geofences) {
  return {
    type: "FeatureCollection",
    features: geofences
      // geofence_type 昇順にソート
      .sort((a, b) => (a.geofence_type ?? 9999) - (b.geofence_type ?? 9999))
      .filter(geofence => geofence.vertexes) // vertexesが存在するもののみ処理
      .flatMap(geofence => {
        let geometry;
        let properties = {
          name: geofence.name,
          color: geofence.color_code
        };

        try {
          const vertexes = JSON.parse(geofence.vertexes); // JSON文字列をオブジェクト化

          if (geofence.geofence_type === 1) {
            // LineString
            geometry = {
              type: "LineString",
              coordinates: vertexes.map(v => [v.lng, v.lat]) // [lng, lat] に変換
            };
          } else if (geofence.geofence_type === 2) {
            // Circle（Point + 半径情報を properties に保持）
            geometry = {
              type: "Point",
              coordinates: [vertexes.center.lng, vertexes.center.lat] // 中心座標
            };
            properties.radius = vertexes.radius; // 半径情報を追加
          } else if (geofence.geofence_type === 3) {
            // Polygon（最初と最後の点を閉じる）
            const coordinates = vertexes.map(v => [v.lng, v.lat]);
            if (
              coordinates.length > 0 &&
              (coordinates[0][0] !== coordinates[coordinates.length - 1][0] ||
                coordinates[0][1] !== coordinates[coordinates.length - 1][1])
            ) {
              coordinates.push(coordinates[0]); // 最初の点を最後に追加して閉じる
            }
            geometry = {
              type: "Polygon",
              coordinates: [coordinates] // GeoJSON Polygon は二重配列
            };
          } else if (geofence.geofence_type === 5) {
            // すでに GeoJSON の場合はそのまま使用
            const tmp = JSON.parse(vertexes); // JSON文字列をオブジェクト化
            if (tmp.type === "FeatureCollection" && Array.isArray(tmp.features)) {
              return tmp.features.map(feature => {
                // tmp 内の name があれば優先
                const featureName = feature.properties?.name || geofence.name;

                //方向指示フラグ
                let destination = feature.geometry.type === "Point" && featureName.includes("Your room");

                return {
                  ...feature,
                  properties: {
                    ...feature.properties,
                    ...properties,
                    name: featureName, // name を上書き
                    destination : destination,//方向指示表示用
                  }
                };
              });
            } else {
              console.warn("Invalid GeoJSON format for geofence_type 5:", vertexes);
              return [];
            }
          } else {
            console.warn("Unsupported geofence_type:", geofence.geofence_type);
            return [];
          }
        } catch (error) {
          console.error("Invalid vertexes data for geofence:", geofence.name, error);
          return [];
        }

        return [{
          type: "Feature",
          properties,
          geometry
        }];
      })
  };
}

